import React from 'react';
import { Box, Card, CardContent, Grid, Button, TextField, MenuItem } from '@mui/material';

interface Account {
  id: number;
  name: string;
  number: string;
}

interface Beneficiary {
  id: number;
  name: string;
  accountNumber: string;
}

interface TransferFormProps {
  fromAccount: string;
  setFromAccount: (value: string) => void;
  beneficiary: string;
  setBeneficiary: (value: string) => void;
  amount: string;
  setAmount: (value: string) => void;
  remarks: string;
  setRemarks: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  accounts: Account[];
  beneficiaries: Beneficiary[];
}

const TransferForm: React.FC<TransferFormProps> = ({
  fromAccount,
  setFromAccount,
  beneficiary,
  setBeneficiary,
  amount,
  setAmount,
  remarks,
  setRemarks,
  onSubmit,
  accounts,
  beneficiaries
}) => (
  <Card>
    <CardContent>
      <form onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              select
              label="Pay From Account"
              value={fromAccount}
              onChange={e => setFromAccount(e.target.value)}
              fullWidth
              required
            >
              {accounts.map(acc => (
                <MenuItem key={acc.id} value={acc.number}>
                  {acc.name} ({acc.number})
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              label="Beneficiary"
              value={beneficiary}
              onChange={e => setBeneficiary(e.target.value)}
              fullWidth
              required
            >
              {beneficiaries.map(b => (
                <MenuItem key={b.id} value={b.accountNumber}>
                  {b.name} ({b.accountNumber})
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Amount"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              type="number"
              fullWidth
              required
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Remarks"
              value={remarks}
              onChange={e => setRemarks(e.target.value)}
              fullWidth
              multiline
              minRows={2}
            />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Transfer
            </Button>
          </Grid>
        </Grid>
      </form>
    </CardContent>
  </Card>
);

export default TransferForm; 